import { PageHeader } from '@clickguard/design-system'
import { AccessLogs } from '../security/access-logs-section'
import { LoginMethod } from '../security/login-method-section'

import { useStores } from 'hooks'
import { useEffect } from 'react'
import { PageTitle } from 'utils/page-title'

export const SecuritySetting = () => {
	const { userStore } = useStores()
	const { user, getUsersEnrollementDetails } = userStore

	useEffect(() => {
		getUsersEnrollementDetails()
	}, [])
	if (!user) return <></>
	return (
		<div className="w-full">
			<PageTitle pageName="Security" />
			<PageHeader
				layout="stacked"
				title="Security"
				subtitle="Manage your login options and history"
			/>
			<div className="flex flex-col gap-4 pt-4">
				<LoginMethod />
				<AccessLogs />
			</div>
		</div>
	)
}
